import React from "react";
import Label from "./Label";

const SubTitle = ({
	className = "", // Add className="error" to show RED colored label.
	text = "Label",
	visible,
	verified = false,
	error = false,
	clickable = false,
	clickable_method = undefined,
	lineHeight = 1,
	...props
}) => {
	return (
		<Label
			id="pageSubTitle"
			className="pageSubTitle"
			text={text}
			visible={visible}
			clickable={false}
			style={{
				fontSize: props?.style?.fontSize ? props?.style?.fontSize : "16px",
				color: props?.style?.color ? props?.style?.color : "#717171",
				fontWeight: props?.style?.fontWeight ? props?.style?.fontWeight : "400px",
				fontFamily: props?.style?.fontFamily ? props?.style?.fontFamily : "pf_handbook_proregular",
				fontStyle: props?.style?.fontStyle ? props?.style?.fontStyle : "normal",
				lineHeight: props?.style?.lineHeight ? props?.style?.lineHeight : "20px",
				textAlign: props?.style?.textAlign ? props?.style?.textAlign : "center",
				marginLeft: props?.style?.marginLeft ? props?.style?.marginLeft : "0",
				...props?.style
			}}
		/>
	);
};
export default SubTitle;
